/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Load_MoreInputs */

const vi_media_load_more = /** @type {(inputs: Media_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải thêm`)
};

/**

* @param {Media_Load_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_load_more = /** @type {((inputs?: Media_Load_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Load_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_load_more(inputs)
});